import { render, staticRenderFns } from "./Handrs.vue?vue&type=template&id=5b61222f&scoped=true&"
import script from "./Handrs.vue?vue&type=script&lang=js&"
export * from "./Handrs.vue?vue&type=script&lang=js&"
import style0 from "./Handrs.vue?vue&type=style&index=0&id=5b61222f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b61222f",
  null
  
)

export default component.exports